export const purposeList = [
  {
    name: "合同",
    code: 0
  },
  {
    name: "打印",
    code: 1
  }
];
export const typeList = [
  {
    name: "文本",
    code: "0"
  },
  {
    name: "数组",
    code: "1"
  },
  {
    name: "布尔值",
    code: "2"
  },
  {
    name: "数组字段",
    code: "3"
  }
];
export const dataSourceList = [
  {
    name: "常量",
    code: "0",
    disabled: false
  },
  {
    name: "模型",
    code: "1",
    disabled: false
  },
  {
    name: "用户",
    code: "2",
    disabled: false
  }
];
export const statusList = [
  {
    name: "停用",
    code: 0
  },
  {
    name: "启用",
    code: 1
  }
];
